<template>
	<div class="edit-form__item">
		<div
			class="wc-checklist"
			:class="schema.style ? schema.style : 'matrix'"
			:disabled="typeof schema.disabled == 'function' ? schema.disabled(model) : schema.disabled"
			:visible="typeof schema.visible == 'function' ? schema.visible(model) : schema.visible"
			v-attributes="'wrapper'"
		>
			<wc-field
				:key="index"
				v-for="(item, index) in items"
				class="wc-checkbox"
				:label="getItemName(item)"
				:disabled="typeof schema.disabled == 'function' ? schema.disabled(model) : schema.disabled"
				position="right"
			>
				<wc-checkbox
					:id="getFieldID(schema)"
					:class="schema.fieldClasses"
					type="checkbox"
					:status="isItemChecked(item) ? 'checked' : 'unchecked'"
					:checked="isItemChecked(item)"
					@change="onChanged($event, item)"
					:disabled="
						typeof schema.disabled == 'function' ? schema.disabled(model) : schema.disabled
					"
					:visible="typeof schema.visible == 'function' ? schema.visible(model) : schema.visible"
					:error="inputError || errors.length !== 0"
					:autocomplete="schema.autocomplete"
					:name="schema.inputName"
					:required="schema.required"
				/>
			</wc-field>
		</div>
		<span class="error-message" v-if="errorMessage">
			<icon icon="status-error" />
			{{ errorMessage }}
		</span>
	</div>
</template>

<script>
import '@25sprout-internal/wc-field';
import '@25sprout-internal/wc-checkbox';
import { isObject, isNil, clone } from 'lodash';
import { abstractField, slugify } from '@backstagex-vue-form-generator/core';
import icon from '@/components/atoms/Icon';

export default {
	mixins: [abstractField],
	props: ['schema', 'model'],
	components: {
		icon,
	},
	data() {
		let column = this.model;
		if (typeof this.schema.column  == 'undefined') {
			this.model.column = [];
		}

		return {
			comboExpanded: false,
			inputError: false,
			errorMessage: ''
		};
	},
	computed: {
		items() {
			let values = this.schema.values;
			if (typeof values == 'function') {
				return values.apply(this, [this.model, this.schema]);
			} else return values;
		},
		selectedCount() {
			if (this.value) return this.value.length;
			return 0;
		},
	},
	methods: {
		getInputName(item) {
			if (this.schema && this.schema.inputName && this.schema.inputName.length > 0) {
				return slugify(this.schema.inputName + '_' + this.getItemValue(item));
			}
			return slugify(this.getItemValue(item));
		},

		getItemValue(item) {
			if (isObject(item)) {
				if (
					typeof this.schema['checklistOptions'] !== 'undefined' &&
					typeof this.schema['checklistOptions']['value'] !== 'undefined'
				) {
					return item[this.schema.checklistOptions.value];
				} else {
					if (typeof item['id'] !== 'undefined') {
						return item.id;
					} else {
						throw '`value` is not defined. If you want to use another key name, add a `value` property under `checklistOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/checklist.html#checklist-field-with-object-values';
					}
				}
			} else {
				return item;
			}
		},

		getItemName(item) {
			if (isObject(item)) {
				if (
					typeof this.schema['checklistOptions'] !== 'undefined' &&
					typeof this.schema['checklistOptions']['name'] !== 'undefined'
				) {
					return item[this.schema.checklistOptions.name];
				} else {
					if (typeof item['name'] !== 'undefined') {
						return item.name;
					} else {
						throw '`name` is not defined. If you want to use another key name, add a `name` property under `checklistOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/checklist.html#checklist-field-with-object-values';
					}
				}
			} else {
				return item;
			}
		},

		isItemChecked(item) {
			return this.value && this.value.indexOf(this.getItemValue(item)) !== -1;
		},

		onChanged(event, item) {
			if (isNil(this.value) || !Array.isArray(this.value)) {
				this.value = [];
			}
			if (event.target.status == 'checked') {
				// Note: If you modify this.value array, it won't trigger the `set` in computed field
				const arr = clone(this.value);
				arr.push(this.getItemValue(item));
				this.value = arr;
			} else {
				// Note: If you modify this.value array, it won't trigger the `set` in computed field
				const arr = clone(this.value);
				arr.splice(this.value.indexOf(this.getItemValue(item)), 1);
				this.value = arr;
			}
			this.validation();
		},

		onExpandCombo() {
			this.comboExpanded = !this.comboExpanded;
		},

		validation() {
			this.inputError = false;
			this.errorMessage = '';

			if (this.schema.required && this.model[this.schema.model].length === 0) {
				this.inputError = true;
				this.errorMessage = this.$t('validation.field_is_required');
			}
		},
	},
};
</script>

<style scoped lang="scss">
wc-checkbox {
	margin-left: 0;
}

.error-message {
	display: flex;

	.icon {
		margin-right: 4px;
	}
}
</style>
